import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";

const NewVsExistingCustomers = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [activeTab, setActiveTab] = useState('existing'); // 'existing' or 'new'
    const [stats, setStats] = useState({
        existing: 0,
        new: 0
    });
    const [customers, setCustomers] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: "",
        daterange: [],
        page: 1,
    });

    
    useEffect(() => {
        getStats();
    }, [apiData.daterange]);

    useEffect(() => {
        getCustomers();
    }, [apiData.page, apiData.search, apiData.daterange, activeTab]);

    const getStats = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "reports/new-vs-existing-customers/stats",
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setStats(data.data);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };

    const getCustomers = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: `reports/new-vs-existing-customers/${activeTab}`,
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setCustomers(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: [],
            page: 1
        });
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setApiData(prev => ({ ...prev, page: 1 })); // Reset to first page when switching tabs
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            New Vs Existing Customers</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Reports</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    
                    {/* Stats Cards */}
                    <div className="row g-5 g-xl-10 mb-5 ">
                        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-md-5">
                            <div 
                                className={`card card-flush mb-5 cursor-pointer ${activeTab === 'existing' ? 'border-primary' : ''}`}
                                onClick={() => handleTabChange('existing')}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            <span className="fs-4 fw-semibold text-gray-500 me-1 align-self-start">Existing</span>
                                            <span className="fs-2hx fw-bold text-dark me-2 lh-1 ls-n2">{stats.existing}</span>
                                        </div>
                                        <span className="text-gray-500 pt-1 fw-semibold fs-6">Customers with 1+ orders</span>
                                    </div>
                                </div>
                                <div className="card-body pt-2 pb-4 d-flex flex-wrap align-items-center">
                                    <div className="d-flex flex-center me-5 pt-2">
                                        <div className="symbol symbol-65px symbol-circle">
                                            <span className="symbol-label bg-light-primary text-primary fs-2x fw-semibold">
                                                <i className="bi bi-people-fill"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column content-justify-center flex-row-fluid">
                                        <div className="d-flex fw-semibold align-items-center font-size-lg">
                                            <span className="bullet bullet-primary vertical-middle d-block me-3"></span>
                                            <span className="text-gray-500">Click to view list</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 ">
                            <div 
                                className={`card card-flush mb-5 cursor-pointer ${activeTab === 'new' ? 'border-primary' : ''}`}
                                onClick={() => handleTabChange('new')}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            <span className="fs-4 fw-semibold text-gray-500 me-1 align-self-start">New</span>
                                            <span className="fs-2hx fw-bold text-dark me-2 lh-1 ls-n2">{stats.new}</span>
                                        </div>
                                        <span className="text-gray-500 pt-1 fw-semibold fs-6">Customers with 0 orders</span>
                                    </div>
                                </div>
                                <div className="card-body pt-2 pb-4 d-flex flex-wrap align-items-center">
                                    <div className="d-flex flex-center me-5 pt-2">
                                        <div className="symbol symbol-65px symbol-circle">
                                            <span className="symbol-label bg-light-success text-success fs-2x fw-semibold">
                                                <i className="bi bi-person-plus-fill"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column content-justify-center flex-row-fluid">
                                        <div className="d-flex fw-semibold align-items-center font-size-lg">
                                            <span className="bullet bullet-success vertical-middle d-block me-3"></span>
                                            <span className="text-gray-500">Click to view list</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Filters and Table */}
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center position-relative my-1">
                                                <input 
                                                    type="text" 
                                                    value={apiData.search} 
                                                    onChange={e => setApiData({ ...apiData, search: e.target.value })} 
                                                    className="form-control form-control-solid me-5"
                                                    placeholder="Search customer name, email, phone.."
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button 
                                                type="button" 
                                                onClick={clearFilter} 
                                                className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange.length ? 'd-none' : ''}`}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="card-body pt-0">
                            <div id="kt_customers_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Customer</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Registration Date</th>
                                                {activeTab === 'existing' && <th>Total Orders</th>}
                                                {activeTab === 'existing' && <th>Last Order</th>}
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {customers.length > 0 ? customers.map((customer, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="symbol symbol-45px me-5">
                                                                <img 
                                                                    src={customer.picture} 
                                                                    alt="Customer" 
                                                                    className="symbol-label"
                                                                    onError={(e) => {
                                                                        e.target.src = '/assets/media/avatars/blank.png';
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="d-flex justify-content-start flex-column">
                                                                <span className="text-dark fw-bold text-hover-primary fs-6">
                                                                    {customer.name}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{customer.email}</td>
                                                    <td>{customer.phone}</td>
                                                    <td>{formatDate(customer.createdAt, 'DD MMM YYYY, hh:mm A')}</td>
                                                    {activeTab === 'existing' && (
                                                        <>
                                                            <td>
                                                                <span className="badge badge-light-primary">
                                                                    {customer.total_orders || 0}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {customer.last_order_date ? 
                                                                    formatDate(customer.last_order_date, 'DD MMM YYYY, hh:mm A') : 
                                                                    'N/A'
                                                                }
                                                            </td>
                                                        </>
                                                    )}
                                                    <td>
                                                        <span className={`badge ${customer.status ? 'badge-light-success' : 'badge-light-danger'}`}>
                                                            {customer.status ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={activeTab === 'existing' ? "7" : "5"} className="text-dark text-center mt-2">
                                                        No {activeTab} customers found!
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center" />
                                    )}
                                    <span>Total Records: {pagination?.total_records || 0}</span>

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewVsExistingCustomers;
